import { wechat } from './modules/wechat'
import { cms } from './modules/cms'
import { coupon } from './modules/coupon'
import { recommend } from './modules/recommend'
import { lottery } from './modules/lottery'
import { cart } from './modules/cart'
import { stockout } from './modules/stockout'
import { moneyTree } from './modules/moneyTree'
import { similygoods } from './modules/similygoods'
import { purchaseList } from './modules/purchaseList'
import { tpPay } from './modules/tpPay'
import { account } from './modules/account'
import { activity } from './modules/activity'
import { delivery } from './modules/delivery'
import { pop } from './modules/pop'
import { personList } from './modules/personList'
import { shippingFee } from './modules/shippingFee'
import { userCenter } from './modules/userCenter'
import { redPackageRain } from './modules/redPackageRain'
import { quarantine } from './modules/quarantine'
import { newReqGood } from './modules/newReqGood'
import { primeCard } from './modules/primeCard'
import { cancelOrder } from './modules/cancelOrder'
import { inspectReport } from './modules/inspectReport'
import { memberIntegral } from './modules/integral'
import { memberCouponPack } from './modules/couponPack'
import { marketResearch } from './modules/marketResearch'
import { homegoods } from './modules/homegoods'

export const API = {
  wechat,
  cms,
  coupon,
  recommend,
  lottery,
  cart,
  stockout,
  moneyTree,
  similygoods,
  purchaseList,
  tpPay,
  account,
  activity,
  personList,
  pop,
  shippingFee,
  userCenter,
  redPackageRain,
  quarantine,
  delivery,
  newReqGood,
  primeCard,
  cancelOrder,
  inspectReport,
  memberIntegral,
  memberCouponPack,
  marketResearch,
  homegoods
}
